import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import GlubesMuiThemeProvider from './components/GlubesMuiThemeProvider/GlubesMuiThemeProvider';
import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute';
import { AppDataProvider } from './context/AppDataContext';
import { ThemeProvider } from './context/ThemeContext';
import { UserProvider } from './context/UserContext';
import AuthorList from './pages/Authors/AuthorList';
import BookCreatePage from './pages/Books/BookCreatePage';
import BookEditPage from './pages/Books/BookEditPage';
import BookList from './pages/Books/BookList';
import HomePage from './pages/HomePage/HomePage';
import ForgotPassword from './pages/Login/ForgotPassword';
import Login from './pages/Login/Login';
import PublicLayout from './pages/Login/PublicLayout';
import ResetPassword from './pages/Login/ResetPassword';
import ManagerUsers from './pages/ManagerUsers/ManagerUsers';
import UserDetails from './pages/ManagerUsers/UserDetails';
import ProfilePage from './pages/Profile/ProfilePage';
import Settings from './pages/Settings/Settings';

function App() {
  return (
    <ThemeProvider>
      <GlubesMuiThemeProvider>
        <UserProvider>
          <AppDataProvider>
            <BrowserRouter>
              <Routes>
                {/* Public-only routes: redirect to /dashboard when already logged in */}
                <Route element={<PublicRoute />}>
                  <Route element={<PublicLayout />}>
                    <Route path="/login" element={<Login />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                  </Route>
                </Route>

                {/* Protected routes: any authenticated user */}
                <Route element={<ProtectedRoute />}>
                  <Route path="/dashboard" element={<HomePage />} />
                  <Route path="/profile" element={<ProfilePage />} />
                  <Route path="/authors" element={<AuthorList />} />
                  <Route path="/library" element={<BookList />} />
                  <Route path="/library/:bookId" element={<BookEditPage />} />
                  <Route path="/books/create" element={<BookCreatePage />} />
                </Route>

                {/* Protected routes: MANAGER role only */}
                <Route element={<ProtectedRoute role="MANAGER" />}>
                  <Route path="/manager/settings" element={<Settings />} />
                  <Route path="/manager/users" element={<ManagerUsers />} />
                  <Route path="/manager/users/new" element={<UserDetails />} />
                  <Route path="/manager/users/:id" element={<UserDetails />} />
                </Route>

                {/* Root redirect: handled by guards above via context */}
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </BrowserRouter>
          </AppDataProvider>
        </UserProvider>
      </GlubesMuiThemeProvider>
    </ThemeProvider>
  );
}

export default App;
